import React, {useState} from 'react';
import PropTypes from 'prop-types';
import {Table} from "reactstrap";
import {get, isEmpty, set} from "lodash";
import useDidMountEffect from "../../../../utils/useDidMountEffect";
import apiUser from "../../../../apiUser";
import PartSetQualColsSelect from "./WorkParts/PartSetQualColsSelect";
import useAfterUpdateEffect from "../../../../utils/useAfterUpdateEffect";
import {isNil} from "lodash/lang";
import AmountSelect from "./WorkParts/AmountSelect";
import {useTranslation} from "react-i18next";
import TecRmiVehicleTypeSuppliers from "../../TecRmiVehicleTypeSuppliers";
import {useTecRmi} from "../../../../contexts/TecRmiContext";

const WorkParts = props => {
  const { getApiPrimaryParams } = useTecRmi()
  const { t } = useTranslation('tec_rmi');
  const [loading, setLoading] = useState(false)
  const [parts, setParts] = useState([])
  const [data, setData] = useState({})

  useDidMountEffect(() => {
    setLoading(true)
    apiUser.tecRmi.prices.partsForWork({
      ...getApiPrimaryParams(),
      ltBodyQualColId: props.bodyForTimes,
      selectedWorkIds: props.workIds,
    })
      .then(res => setParts(parseParts(res.data)))
      .finally(() => setLoading(false))
  })

  useAfterUpdateEffect(() => {
    if(props.onChange){
      props.onChange({
        parts,
        data,
      })
    }
  }, [parts, data])

  const parseParts = (parts) => {
    let _parts = {}

    parts.forEach(part => part.PartSetQualCols.forEach(partSetQualCol => partSetQualCol.Parts.forEach(_part => {
      if(!get(_parts, `${_part.ItemMpId}`)){
        set(_parts, `${_part.ItemMpId}`, _part)
      }
      set(_parts, `${_part.ItemMpId}.partQualCols.${_part.PartQualColId}`, _part)
    })))
    _parts = Object.values(_parts).map(part => ({
      ...part,
      partQualCols: Object.values(part.partQualCols)
    }))

    return _parts
  }

  return <Table bordered>
    <thead>
    <tr>
      <th>{t('work_parts.parts_list')}</th>
      <th width={300}>{t('work_parts.details')}</th>
      <th width={250}>{t('work_parts.quantity')}</th>
    </tr>
    </thead>
    <tbody>
    {
      loading
        ? <tr><td colSpan={3} className="text-center"><i className="fas fa-spinner fa-spin" /></td></tr>
        : isEmpty(parts)
          ? <tr><td colSpan={3} className="text-center"><span>{t('common:no_data')}</span></td></tr>
          : Object.values(parts).map((part, key) => {
            return <tr key={key.toString()}>
              <td>
                <div className="d-flex flex-row flex-nowrap justify-content-between align-items-center">
                  <span>{part.ItemMpText}</span>
                  <TecRmiVehicleTypeSuppliers />
                </div>
              </td>
              <td>
                <PartSetQualColsSelect
                  partSetQualCols={part.partQualCols}
                  onChange={partQualColId => {
                    let _data = set(data, `${part.ItemMpId}.partSetQualCol.partQualColId`, partQualColId)
                    _data = set(_data,`${part.ItemMpId}.amount.qualColId`, null)
                    setData({..._data})
                  }}
                />
              </td>
              <td>{
                isNil(get(data, `${part.ItemMpId}.partSetQualCol.partQualColId`))
                  ? <i></i>
                  : <AmountSelect
                    value={get(data, `${part.ItemMpId}.amount.qualColId`)}
                    part={part.partQualCols.find(partQualCol => partQualCol.PartQualColId === get(data, `${part.ItemMpId}.partSetQualCol.partQualColId`))}
                    onChange={qualColId => setData({...set(data,`${part.ItemMpId}.amount.qualColId`, qualColId)})}
                  />
              }</td>
            </tr>
          })
    }
    </tbody>
  </Table>
};

WorkParts.propTypes = {
  bodyForTimes: PropTypes.number.isRequired,
  workIds: PropTypes.arrayOf(PropTypes.number).isRequired,
  onChange: PropTypes.func,
};

export default WorkParts;